/**
 * Build display groups from a backend cross (tree) report response.
 * The backend already aggregated each top group with the provider's own totals
 * (so they match the panel) and listed the nested leaves — we just adapt to the
 * StatsTable group shape and sort. For Media Devoted | Created By Ciro Autiero
 */

import type {
  CrossStatsLeaf,
  CrossStatsResponse,
} from '@/features/smswiser-campaigns/types/workspace.types';

import type { GenericStatsRow } from '../generic-stats.types';
import type { StatsGroupGeneric } from './build-groups';
import { sortGroupsByField } from './sort-groups';

function leafToRow(
  leaf: CrossStatsLeaf,
  groupKey: string,
  index: number,
): GenericStatsRow {
  return {
    id: `${groupKey}::${leaf.id}::${index}`,
    label: leaf.label || '—',
    leafId: leaf.id,
    voluum: leaf.voluum,
    searchText: (leaf.label ?? '').toLowerCase(),
  };
}

export function buildCrossStatsGroups(
  response: CrossStatsResponse | undefined,
  sort: { field: string; dir: 'asc' | 'desc' } | null,
): StatsGroupGeneric[] {
  if (!response) return [];
  const groups = response.groups.map((g) => ({
    key: g.key || '—',
    label: g.label || '—',
    totals: g.totals ?? {},
    rows: g.leaves.map((lf, i) => leafToRow(lf, g.key || '—', i)),
  }));
  return sortGroupsByField(groups, sort);
}
